import "react/jsx-runtime";
import "./_baseGetTag.mjs";
import "./_stringToPath.mjs";
import "./_baseToString.mjs";
import "react";
import "@mui/material";
import { StennLogoBlack as t } from "./StennLogoBlack.mjs";
import { StennLogoCompact as o } from "./StennLogoCompact.mjs";
import { StennLogoBlackCompact as m } from "./StennLogoBlackCompact.mjs";
import { StennLogoDark as r } from "./StennLogoDark.mjs";
import { StennLogoWhite as i } from "./StennLogoWhite.mjs";
import { StennLogoLight as p } from "./StennLogoLight.mjs";
import { StennLogoWhiteCompact as n } from "./StennLogoWhiteCompact.mjs";
const d = {
  light: {
    primary: {
      compact: o,
      fullSize: p
    },
    secondary: {
      compact: m,
      fullSize: t
    }
  },
  dark: {
    primary: {
      compact: o,
      fullSize: r
    },
    secondary: {
      compact: n,
      fullSize: i
    }
  }
};
export {
  d as STENN_LOGO
};
//# sourceMappingURL=constants22.mjs.map
